/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Accept_ErrorInputs */

const en_applicants_bulk_accept_error = /** @type {(inputs: Applicants_Bulk_Accept_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to accept applications`)
};

const de_applicants_bulk_accept_error = /** @type {(inputs: Applicants_Bulk_Accept_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen konnten nicht angenommen werden`)
};

/**
* | output |
* | --- |
* | "Failed to accept applications" |
*
* @param {Applicants_Bulk_Accept_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_accept_error = /** @type {((inputs?: Applicants_Bulk_Accept_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Accept_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_accept_error(inputs)
	return en_applicants_bulk_accept_error(inputs)
});